import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const COOKIE_CONSENT_KEY = "zelt-cookie-consent";

export function CookieConsent({ onNavigate, offsetForBar = false }: { onNavigate: (path: string) => void; offsetForBar?: boolean }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie-Einstellungen"
      className={cn(
        "fixed right-4 z-[100] max-w-xs",
        offsetForBar ? "bottom-24" : "bottom-4",
        "animate-in slide-in-from-bottom-4 fade-in duration-500"
      )}
    >
      <div className={cn(
        "rounded-xl p-4",
        "bg-card border shadow-lg shadow-black/5 dark:shadow-black/20",
        "backdrop-blur-xl"
      )}>
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground leading-relaxed">
              Wir nutzen Cookies für Grundfunktionen (Dark Mode, Vergleichsliste).{" "}
              <button
                onClick={() => { onNavigate("/datenschutz"); decline(); }}
                className="text-primary hover:underline"
              >
                Mehr erfahren
              </button>
            </p>
            <div className="flex gap-2 mt-2.5">
              <button
                onClick={accept}
                className="text-xs font-medium px-3 py-1.5 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                OK
              </button>
              <button
                onClick={decline}
                className="text-xs font-medium px-3 py-1.5 rounded-lg border border-border hover:bg-muted transition-colors"
              >
                Ablehnen
              </button>
            </div>
          </div>
          <button
            onClick={decline}
            className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0 mt-0.5"
            aria-label="Schließen"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
